// extracted by mini-css-extract-plugin
export default {"base":"TextArea_base__EJgDC","error":"TextArea_error__V0uRz","errorText":"TextArea_errorText__4isGf"};